import React from "react";
import Div100vh from "react-div-100vh";

import Benefits from "@/components/common/Benefits";
import WhatsappIcon from "@/assets/icons/whatsapp-icon.webp";
import WhiteBgCard from "@/assets/images/membership-benefits.svg";
import CrownIcon from "@/assets/images/crow.png";
import { SwipeableButton } from "@/components/common/buttons/SwipeableButton";
import BenefitCard from "../common/Card/BenefitCard";
import GoBackButton from "../common/buttons/GoBackButton";
import { useRecoilState } from "recoil";
import { onboardingFormDataAtom } from "@/recoil/atom/onboardingFormDataAtom";
import BenefitsImgOne from "@/assets/images/benefits-card-one.svg";
import BenefitsImgTwo from "@/assets/images/benefits-card-two.svg";

export default function MembershipBenefitsScreen() {
  const [data, setData] = useRecoilState(onboardingFormDataAtom);
  if (data === null) {
    setData({ full_name: "Satyakam Singhal" });
  }
  const first_name = data?.full_name?.split(" ")[0];
  return (
    <Div100vh className="flex flex-col justify-between py-4 touch-none items-center">
      <div className="px-4 flex w-full items-start justify-start">
        <GoBackButton />
      </div>
      <div className="relative inline-block items-start self-start w-fit gap-5">
        <div className="flex flex-col justify-start items-start self-start px-4 ">
          <span className="font-medium text-2xl sm:text-3xl">Benefits of</span>
          <div className="absolute top-6 right-0 transform translate-x-1/2 -translate-y-1/2">
            <img src={CrownIcon} alt="crown-icon" className="w-16 h-16" />
          </div>
          <span className="font-semibold text-2xl sm:text-3xl">
            CirclePe Club
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-8 justify-center items-center">
        <img
          src={BenefitsImgOne}
          alt="benefits-img-two"
          className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl object-contain"
        />
        <img
          src={BenefitsImgTwo}
          alt="benefits-img-one"
          className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl object-contain"
        />
      </div>

      <SwipeableButton screen={"/eligibility-check"} />
    </Div100vh>
  );
}
